import { useTranslation } from "react-i18next";

import ActionButtonLayout from "./ActionButtonLayout";

function ModifyTranslationValueButtonLayout ( props ) {

    const { t } = useTranslation();

    return <ActionButtonLayout {...props}>{t("buttonName.modifyTranslationValue")}</ActionButtonLayout>;

}

export default ModifyTranslationValueButtonLayout;

